import styled from "styled-components";

export const StyledCallOfferingItemWrapper = styled.div`
  display: grid;
  gap: 2.1rem;
  /* flex-wrap: wrap; */
  /* grid-template-columns: repeat(2, 1fr); */
  grid-template-columns: repeat(1, 1fr);
  /* @media only screen and (max-width: 425px) {
  } */
`;

export const StyledCallOfferingItem = styled.div<{active?: boolean}>`
  cursor: pointer;
  background-color: ${({active}) => (active ? "#EAE6F3" : "#fff")};
  border: 1.5px solid ${({active}) => (active ? "#2E2640" : "#D9D9D9")};
  border-radius: 5px;
  padding: 1rem;
  display: flex;
  align-items: center;
  gap: 1.4rem;
  /* flex-wrap: wrap; */

  .content-wrapper {
    display: flex;
    align-items: center;
    gap: 2rem;
    .icon-container {
      background: ${({active}) => (active ? "#EAE6F3" : "#f5f5f5")};
      border-radius: 4px;
      font-size: 3rem;
      padding: 1.7rem;
      /* align-self: stretch; */
      // width: 6.6rem;
      /* display: flex;
    align-items: center;
    justify-content: center; */
      /* align-self: center; */
      color: #1c1726;
      width: fit-content;
      /* height: 6.6rem; */
    }
    .location-info {
      color: #1c1726;
      margin-top: 1.4rem;
      .title {
        font-weight: 600;
        font-size: 1.4rem;
      }
      .sub-info {
        font-weight: 400;
        font-size: 1.4rem;
      }
    }
  }

  @media only screen and (max-width: 450px) {
    /* .icon-container {
      align-self: center;
    } */
    .location-info {
      .sub-info {
        font-size: 1.2rem;
      }
    }
  }
`;
